// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__5amle","left":"InfoRow_left__3OFNL"};